import * as Sentry from '@sentry/angular';

export function shouldIgnoreSentryError(event: Sentry.Event): boolean {
  const ignoredErrors = [
    {
      type: 'InvalidStateError',
      messageIncludes: 'document visibility state is hidden',
    },
    {
      type: 'InvalidStateError',
      messageIncludes: 'Skipping view transition',
    },
    {
      type: 'AbortError',
      messageIncludes: 'Old view transition aborted by new view transition',
    },
    {
      type: 'Error',
      messageIncludes: 'ng0750',
    },
  ];

  const exceptions = event.exception?.values ?? [];

  const hasIgnoredException = exceptions.some((ex) => {
    const exType = safeToLower(ex.type);
    const exValue = safeToLower(ex.value);

    return ignoredErrors.some(
      (rule) =>
        exType === safeToLower(rule.type) &&
        exValue.includes(safeToLower(rule.messageIncludes))
    );
  });

  if (hasIgnoredException) return true;

  // Fallback: check event.message (some errors might not have exception values)
  if (event.message) {
    const msg = safeToLower(event.message);
    return ignoredErrors.some(
      (rule) =>
        msg.includes(safeToLower(rule.type)) &&
        msg.includes(safeToLower(rule.messageIncludes))
    );
  }

  return false;
}

function safeToLower(str?: string): string {
  return (str ?? '').toLowerCase();
}
